import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlay, FiCalendar } = FiIcons;

const CTABlock = () => {
  return (
    <section className="cta-block section hero-gradient text-white">
      <div className="container">
        <motion.div
          className="cta-content text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            אל תפסידו את התיק הבא בגלל מענה איטי.
          </h2>
          
          <p className="text-xl lg:text-2xl mb-12 text-gray-200 leading-relaxed">
            Botley עונה בשם המשרד, מעלה את ערך הלידים, ומביא את הלקוח לשלב הבא – תמיד.
          </p>
          
          <div className="cta-buttons flex flex-col sm:flex-row gap-6 justify-center">
            <motion.a
              href="https://link.botley.co.il/farbman-law-video"
              className="btn btn-primary text-xl px-8 py-4"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiPlay} />
              צפה בהדגמה חיה
            </motion.a>
            <motion.a
              href="https://link.botley.co.il/botley_demo_website"
              className="btn btn-secondary text-xl px-8 py-4"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiCalendar} />
              קבע הדגמה אישית
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABlock;